module.exports = __webpack_public_path__ + "img/posterminal.7263caf4.png";